import { Helper } from "../core/util/helper.js";

export class MappingService {
    private static additionalMapping = {
        "Project": {
            "Projnrref": "HauptProjekt"
        },
        "emailTemplate": {
            "DisplayName": "name"
        }
    }

    public static tryMap = (searchType: string, entity: {}) => {
        try {
            const object: Object = {};
            Object.keys(entity).forEach((key: string) => {
                Object.defineProperty(object, key.toLowerCase(), {
                    value: entity[key],
                    writable: true,
                    enumerable: true
                })
            })
            const additionalMapping = MappingService.additionalMapping[searchType];
            if (Helper.hasValue(additionalMapping)) {
                Object.keys(additionalMapping).forEach((key: string) => {
                    if (object.hasOwnProperty(additionalMapping[key])) {
                        object[additionalMapping[key]] = entity[key]
                    } else {
                        Object.defineProperty(object, additionalMapping[key], {
                            value: entity[key]
                        })
                    }
                })
            }
            return object;
        } catch {
            return null;
        }
    }

}